<template>
  <div id="app">
    <!--映入的模板-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  padding: 0;
  margin: 0
}
</style>



// WEBPACK FOOTER //
// src/App.vue